import { Dropdown } from "react-bootstrap";
import storage from "../services/storage";
import PinTool from "../assets/images/pen-tool.svg";
import ClipBoard from "../assets/images/clipboard.svg";
import greyledAssign from "../assets/images/greyled_assign.svg";
import greyledTeach from "../images/logo.svg";
import greyledCreate from "../assets/images/model/logo.svg";
import BookShelf from "../assets/images/bookshelf.svg";
import CarrotDown from "../assets/images/arrow_down_green.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function GrayledDropdown({ mode, notAllowed = false, setLink = () => {} }) {
  let storedBookId = localStorage.getItem("lastBookId");
  if (!storedBookId) {
    storedBookId = storage.get("user").isBookOpened;
  }
  const { book } = useSelector((state) => state.entities);
  const { token } = useSelector((state) => state.auth);

  return (
    <div>
      <Dropdown className="customized-dropdown">
        <Dropdown.Toggle className="customized-dropdown-button">
          {" "}
          <img
            src={
              mode === "assign"
                ? greyledAssign
                : mode === "teach"
                ? greyledTeach
                : mode === "create"
                ? greyledCreate
                : greyledAssign
            }
            alt=""
          />
          {mode !== "assign" && mode !== "create" && (
            <img src={CarrotDown} alt="" style={{ marginLeft: "8px" }} />
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ width: mode === "teach" ? "100%" : "" }}>
          <Dropdown.Item
            as={"button"}
            className={`${mode === "teach" ? "active" : ""}`}>
            <Link
              to={"/dashboard"}
              onClick={(e) => {
                if (notAllowed) {
                  e.preventDefault();
                  e.stopPropagation();
                  setLink("/dashboard");
                  return;
                }
                if (mode === "assign") {
                  localStorage.setItem("mode", "assigned-mode");
                } else if (mode === "create") {
                  localStorage.setItem("mode", "create-mode");
                }
              }}>
              <span className="icon-svg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="book-open">
                    <path
                      id="Vector"
                      d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
                      stroke="#2E2E2D"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
                      stroke="#2E2E2D"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>{" "}
              Teach
            </Link>
          </Dropdown.Item>
          <Dropdown.Item
            as={"button"}
            className={`${mode === "assign" ? "active" : ""}`}>
            <Link
              to={`/assign/${book._id}`}
              onClick={(e) => {
                if (notAllowed) {
                  e.preventDefault();
                  e.stopPropagation();
                  setLink(`/assign/${book._id}`);
                  return;
                }
              }}>
              <img src={ClipBoard} alt="" /> assign
            </Link>
          </Dropdown.Item>
          <Dropdown.Item
            as={"button"}
            className={`${mode === "create" ? "active" : ""}`}>
            <Link
              to={`${storedBookId ? `/create/${storedBookId}` : "createbook"}`}
              onClick={(e) => {
                if (notAllowed) {
                  e.preventDefault();
                  e.stopPropagation();
                  setLink(
                    `${storedBookId ? `/create/${storedBookId}` : "createbook"}`
                  );
                  return;
                }
              }}>
              <img src={PinTool} alt="" /> create
            </Link>
          </Dropdown.Item>
          <Dropdown.Item
            as={"button"}
            className={`${mode === "explore" ? "active" : ""}`}>
            <Link
              to={"https://www.greyled.com?token=" + token}
              target="_blank"
              onClick={(e) => {
                if (notAllowed) {
                  e.preventDefault();
                  e.stopPropagation();
                  setLink("https://www.greyled.com?token=" + token);
                  return;
                }
              }}>
              <img src={BookShelf} alt="" /> explore
            </Link>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default GrayledDropdown;
